<template>
  <v-form ref="form" >

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>      

      <v-col cols="12" sm="12" md="12">
        <v-autocomplete
          v-model="entry.manufacturingLotId"
          v-bind="getObject('manufacturingLotId')"
          label="Lote"
          :items="this.lotItemsList"
          @input="changeSelectedItem"          
          item-value="id"
          item-text="name"
          :disabled="readOnly"
          autocomplete="off"
        >
        <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title class="text-subtitle-1">{{data.item.name}}</v-list-item-title>
              <v-list-item-subtitle>
                Qtd. disponível: {{data.item.availableQuantity}} {{data.item.unitName}} - Qtd. de emb.: {{data.item.packagingQuantity}} {{data.item.packagingName}}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6">
        <MaskedTextField
          v-if="renderComponent"
          :inputData.sync="entry.packagingQuantity"
          mask-type="currency_10d"
          label="Quantidade de Embalagens"      
          @update:inputData="changePackagingQuantity"
          autocomplete="off"
          :hint="packagingHint"
          persistent-hint
          :suffix="packaging ? packaging.text : ''"
          :key="packagingQuantityKey + 'packagingQuantity'"
        />
        <!--   -->
      </v-col>

      <v-col cols="12" sm="6">
        <MaskedTextField
          v-if="renderComponent"
          v-bind="getObject('quantity')"          
          :inputData.sync="entry.quantity"
          mask-type="currency_10d"
          label="Quantidade Unitária"          
          @update:inputData="changeQuantity"
          :hint="quantityHint"
          persistent-hint
          autocomplete="off"
          :suffix="movementItem.item ? movementItem.packaging.unitName : ''"
          :key="quantityKey + 'quantity'"
        />
        <!-- -->
      </v-col>

      <v-col cols="12" sm="6" v-if="seedPlotOperation && seedPlotOperation.operationTypeId == 17 && movementItem.item.unit.name != 'UNID' && movementItem.item.type == 'Seed' ">
        <MaskedTextField
          v-if="renderComponent"          
          :inputData.sync="entry.packagingUnitQuantity"
          mask-type="currency_10d"
          label="Qtd. de bandejas"
          @update:inputData="changePackagingUnitQuantity"
          autocomplete="off"
          :hint="trayHint"
          persistent-hint
          :suffix="'UNID'"
          :key="packagingUnitQuantityKey + 'packagingUnitQuantity'"
        />
      </v-col>

      <v-col cols="12" sm="6" v-if="seedPlotOperation && seedPlotOperation.operationTypeId == 17 && movementItem.item.unit.name != 'UNID' && movementItem.item.type == 'Seed' ">
        <MaskedTextField
          v-if="renderComponent"
          v-bind="getObject('unitQuantity')"          
          :inputData.sync="entry.unitQuantity"
          @update:inputData="changeUnitQuantity"
          mask-type="currency_10d"
          label="Quantidade Unitária"
          autocomplete="off"
          :suffix="'UNID'"
          :key="unitQuantityKey + 'unitQuantity'"
        />
        <!-- -->
      </v-col>

       
     
    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import gql from 'graphql-tag'
import BaseUtil from "@shared_components/base_util.vue"
import DateField from "@shared_components/date_field.vue";

export default {
  data() {
    return {
      entryAttributes: {},      
      lotItemsList: [],
      renderComponent: true,
      itemsSearch: "",
      unitPriceKey: 0,
      totalPriceKey: 0,
      packagingQuantity: 0,
      packagingQuantityKey: 0,
      packagingUnitQuantityKey: 0,
      quantityKey: 0,
      unitQuantityKey: 0,
      packagingPriceKey: 0,
      pageLoading: false,
      itemSelected: {},
      availableQuantity: 0,
      interizator: 10000000000.0,
    };
  },
  props: {
    entry: Object,
    originalEntry: Object,
    movementItem: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
    packaging: Object,
    itemLots: {
      type: Array,
      default: new Array(),
    },
    storageAdjustment: Object,
    isNewItemInStorage: {
      type: Boolean,
      default: false,
    },
    seedPlotOperation: {
      type: Object,
      default: null,
    }
  },
  components: {
    MaskedTextField: MaskedTextField,
    BaseUtil: BaseUtil,
    DateField: DateField,
  },
  created() {    
    // console.log("form created", this.movementItem);

    this.entryAttributes = this.setupEntryAttributes(this.entry);
    if (this.entryAttributes.manufacturingLotId) {
      // this.purchaseItemsList = [this.entry.item];
      // this.selectItem(false);
      this.changeSelectedItem();
      this.changePackagingQuantity();
      // console.log("if", "ok");
      this.entry.quantity = this.movementItem.quantity;      
      this.changeQuantity();
    }
    
    this.loadItemLots();    
  },
  mounted() {
  },
  computed: {
    quantityHint: function() {
      var availableQuantity =  parseFloat(this.itemSelected?.availableQuantity);
      if(this.isEdit && this.originalEntry.id){
        availableQuantity += this.originalEntry.quantity;
      }
      return (this.entry.manufacturingLotId && this.itemSelected) ? "Quantidade disponível: " + this.numberToDecimal(availableQuantity) + " " + this.itemSelected?.unitName : "";
    },
    packagingHint: function(){
      return this.packaging.name;
    },
    trayHint: function(){
      return this.movementItem.tray.name;
    },

  },
  watch: {
    itemsSearch: function(newSearch, oldSearch) {
      // console.log("newSearch", newSearch, "oldSearch", oldSearch)
      // if (this.itemsSearch && this.itemsSearch.length > 0) {
      //   if (!this.entry.item || this.entry.item.name != this.itemsSearch) {
      //     this.getPurchaseItems();
      //   }
      // }
    }
  },
  methods: {    
    loadItemLots: function(){
      for(var i=0;i<this.itemLots.length; i++){
        this.lotItemsList.push(this.itemLots[i]);
      }
      // console.log("lots", this.lotItemsList);
      // console.log("en", this.entry);
      if(this.lotItemsList.length==1){
        this.entry.manufacturingLotId = this.lotItemsList[0].id;
      }    
      this.changeSelectedItem();
    },
    availableLotQuantity: function(){
      if(this.entry.manufacturingLotId){
        this.$apollo
            .query({
              query: AVAILABLE_LOT_QUANTITY_FOR_ITEM_QUERY,
              fetchPolicy: "no-cache",
              variables: {
                itemId: this.movementItem.itemId,
                packagingId: this.movementItem.packagingId,
                storageId: this.storageAdjustment.storageId,
                movementItemLotId: this.entry.id,
                itemLotId: this.entry.manufacturingLotId || null,
              }
            })
            .then(response => {
              // console.log("response dos storages", response)                        
              // this.entryAttributes.quantity.rules = []
              if(!this.itemSelected){
                this.itemSelected = {};
              }
              this.itemSelected.availableQuantity = response.data.accountContext.availableLotQuantity;
              this.itemSelected.unitName = this.packaging.unitName;
              // console.log("response", response.data.accountContext.availableLotQuantity);             
              var availableQuantity =  parseFloat(this.itemSelected?.availableQuantity);
              if(this.isEdit && this.originalEntry.id){
                availableQuantity += this.originalEntry.quantity;
              }
              this.entryAttributes.quantity.rules.push(this.maxValueRule(availableQuantity));
              
              // console.log("fez busca !!!", this.itemLots);
              this.changePackagingQuantity();
              // console.log("item selected", this.itemSelected);            
            })
            .catch(response => console.log(response))
            .finally(() => (this.availableQuantityLoading = false)); 
      }     
    },
    changeSelectedItem: function(){
      this.itemSelected = this.lotItemsList.find(obj => obj.id == this.entry.manufacturingLotId);      
      // console.log("item", this.itemSelected);
      // console.log("storageAdjustment", this.storageAdjustment);
      
      this.entryAttributes.quantity.rules = []
      var availableQuantity =  parseFloat(this.itemSelected?.availableQuantity);
      if(this.isEdit && this.originalEntry.id){
        availableQuantity += this.originalEntry.quantity;
      }
      if(availableQuantity){
        this.entryAttributes.quantity.rules.push(this.maxValueRule(availableQuantity));
      }
            
      this.setItemLot(this.itemSelected);
      
      this.changePackagingQuantity();
      // this.availableLotQuantity();
    },    
    changeQuantity: function() {
      this.entry.packagingQuantity = _.round(this.entry.quantity / this.packaging.size, 10);      
      this.packagingQuantityKey++;
      // this.updateQuantity();
      // if(this.itemSelected){
      //   this.changeSelectedItem();
      // }
    },   
    changePackagingQuantity: function() {
      // console.log("pk size",this.entry.packagingQuantity);
      var temp = (Math.floor(this.entry.packagingQuantity * this.interizator) * this.packaging.size) / this.interizator;
      // console.log("temp", temp);
      this.entry.quantity = _.round(temp, 10);
      this.quantityKey++;
      // this.updateQuantity();
    },
    changeUnitQuantity: function() {
      this.entry.packagingUnitQuantity = _.round(this.entry.unitQuantity / this.movementItem.tray.size, 10);      
      this.packagingUnitQuantityKey++;            
    },   
    changePackagingUnitQuantity: function() {
      // console.log("pk size",this.movementItem.tray);
      this.entry.unitQuantity = _.round(this.entry.packagingUnitQuantity * this.movementItem.tray.size, 10);
      this.unitQuantityKey++;
      // this.updateQuantity();
    }, 
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },    
    clearFields: function() {
      this.forceRerender(this);
    },
    setItemLot: function(itemLot){
      if(itemLot){
        this.entry.name = itemLot.name;
        this.entry.newName = itemLot.newName;
        this.entry.lotNumber = itemLot.lotNumber;
        this.entry.manufacturingDate = itemLot.manufacturingDate;
        this.entry.dueDate = itemLot.dueDate;
        this.entry.availableQuantity = itemLot.availableQuantity;
        this.entry.unitName = itemLot.unitName;
        this.entry.quantity = itemLot.quantity;                
      }
    },
    selectItemLot: function(item){
      // console.log("item", item);
      for (let i in this.lotItemsList){
        // console.log("i", i);
        if(this.lotItemsList[i].id == item){
          this.setItemLot(this.lotItemsList[i]);
        }
      }
      // console.log("entry", this.entry);
    },
    itemCreated: function(item) {
      // console.log("item created", item);
      this.lotItemsList.unshift(item);
      this.entry.manufacturingLotId = item.id;      
      item.quantity = this.quantity;
      item.packagingQuantity = this.packagingQuantity;
      this.setItemLot(item);
      // console.log("item", item);
      // this.selectItem(true);
    },
    isNewLotChanged: function(){

    }
  }
};

const AVAILABLE_LOT_QUANTITY_FOR_ITEM_QUERY = gql `
  query ($itemId: ID!, $packagingId: ID!, $storageId: ID!, $movementItemLotId: ID, $itemLotId: ID!) {
    accountContext {
      availableLotQuantity(itemId: $itemId, packagingId: $packagingId, storageId: $storageId, movementItemLotId: $movementItemLotId, itemLotId: $itemLotId)
    }
  }
`;

</script>

<style scoped></style>
